/** The Tidy pill's rule (deliverable 23, open point 5): an `import` revision among the newest. Pure. */
import type { RevisionSummaryV1 } from '@codex/contracts';

export const TIDY_READ_ONLY_COPY = "Tidy suggestions can't open while the page is read-only.";

/** True when one of the page's newest revisions was written by an import. */
export function wasImported(
  revisions: readonly Pick<RevisionSummaryV1, 'reason'>[] | undefined,
): boolean {
  return (revisions ?? []).some((revision) => revision.reason === 'import');
}
